import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=1b2f2d8b&scoped=true&"
import script from "./ImportExport.vue?vue&type=script&lang=js&"
export * from "./ImportExport.vue?vue&type=script&lang=js&"
import style0 from "./ImportExport.vue?vue&type=style&index=0&id=1b2f2d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f2d8b",
  null
  
)

export default component.exports